import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Table, Empty, Tag } from 'antd';
import moment from 'moment';
import './styles.css';

import { FORMAT_NUMBER ,FORMAT_3DECIMALS} from '../../../common/types/regularExpresionType';

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

const  tipo_requeremiento = [ {codigo:1, nombre:"Bienes"}, {codigo:2, nombre:"Servicios"} ]

class FormModalVer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    render() {
        debugger
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.iD });
        getFieldDecorator('arrDetalle', { initialValue: [] });
        
        return (
            <Modal
                title="Ver requerimiento"
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okButtonProps={{ style: {display: 'none'}}}
                onCancel={this.handleCancel}
                width="800px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => this.props.onChange('fechaStr', value)}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>

                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie,
                                            rules: [{
                                                required: true,
                                                //message: 'Requerido',
                                                whitespace: true
                                            }]
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                readOnly={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento,
                                            rules: [{
                                                required: true,
                                                //message: 'Requerido',
                                                whitespace: true
                                            }]
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                readOnly={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Dias / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('diasVencimiento', {
                                            initialValue: this.props.formValues.diasVencimiento,
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_NUMBER),
                                                message: "Formato incorrecto"
                                            }]
                                        })(
                                            <Input
                                                style={{ textAlign: 'right' }}
                                                autoComplete="off"
                                                className="first-input"
                                                readOnly={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaVencimientoStr', {
                                            initialValue: moment(this.props.formValues.fechaVencimientoStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">

                    <div className="col-md-3 form-group">
                            <Form.Item label="Nro Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('documentoEntidad', {
                                            initialValue: this.props.formValues.documentoEntidad,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Search
                                                placeholder="Numero de documento / Nombre”"
                                                className="first-input"
                                                autoComplete="off"
                                                loading={this.props.formValues.entidadLoading}
                                                onSearch={value => this.props.onBuscarEntidad(value)}
                                            />
                                        )}
                                    </Form.Item>
                        
                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-9 form-group">
                            <Form.Item label="Entidad">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('idEntidad', {
                                            initialValue: this.props.formValues.entidad 
                                        })(
                                            <Input
                                                autoComplete="off"
                                                className="first-input"
                                                readOnly={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
               
                    </div>

                    <div className="row">
                    <div className="col-md-9 form-group">
                            <Form.Item label="Dirección">
                                {getFieldDecorator('idEstablecimientoEntidad', {
                                    initialValue: this.props.formValues.direccionEntidad
                                })(
                                    <Input
                                        style={{ textAlign: 'left' }}
                                        autoComplete="off"
                                        readOnly={true}
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.nombreProyecto 
                                })(
                                    <Input
                                        style={{ textAlign: 'left' }}
                                        autoComplete="off"
                                        readOnly={true}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        
                    <div className="col-md-4 form-group">
                            <Form.Item label="Tipo">
                                {getFieldDecorator('codigoTipo', {
                                    initialValue: this.props.formValues.codigoTipo ?
                                        { key: this.props.formValues.codigoTipo } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo"}
                                        optionFilterProp="children"
                                        readOnly={true}
                                        >
                                        {tipo_requeremiento.map(item => (
                                            <Option key={item.codigo} value={item.codigo}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-8 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                        readOnly={true}
                                    />
                                )}
                            </Form.Item>
                        </div>
              
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    
                                    <Table
                                        className={'table-producto'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        rowKey={record => record.idProducto}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='Pulse el botón "+ Agregar".'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Código',
                                                dataIndex: 'codigo',
                                                key: 'codigo',
                                                align: 'center',
                                                width: 100,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Nombre',
                                                dataIndex: 'nombre',
                                                key: 'nombre',
                                                width: 370,
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Unidad Medida',
                                                dataIndex: 'nombreUnidadMedida',
                                                key: 'nombreUnidadMedida',
                                                width: 120,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Cantidad',
                                                dataIndex: 'cantidad',
                                                key: 'cantidad',
                                                align: 'center',
                                                width: 90
                                            },

                                        ]}
                                    />



                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    

                                    <Table
                                        className={'table-referencia'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        rowKey={record => record.identifier}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='Pulse el botón "+ Agregar".'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Tipo Comprobante',
                                                dataIndex: 'nombreTipoComprobante',
                                                key: 'nombreTipoComprobante',
                                                align: 'center',
                                                width: 350,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Serie',
                                                dataIndex: 'serie',
                                                key: 'serie',
                                                width: 100,
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Documento',
                                                dataIndex: 'documento',
                                                key: 'documento',
                                                width: 120,
                                                ellipsis: true
                                            }
                                        ]}
                                    />


                                </TabPane>
                            </Tabs>
                        </div>
                    </div>

                </Form>
            </Modal>
        )
    }
}
export default Form.create()(FormModalVer)